/* eslint-disable valid-jsdoc */
import { AVAILABLE_LANGUAGES, FALLBACK_LOCALE, LOCALES_MAPPING } from '../constants'

const getFallbackLocale = (language, rawLangcode) => {
    if (language?.locale) {
        return language.locale
    }

    const foundFallback = LOCALES_MAPPING[rawLangcode]?.fallbackLocale

    if (foundFallback) {
        return rawLangcode
    } else {
        return FALLBACK_LOCALE
    }
}

/**
 * match the language by different browsers
 * @type object
 */
function parseLocale(lang) {
    if (lang?.length === 5) {
        lang = `${lang.substring(0, 2)}-${lang.substring(3).toUpperCase()}`
        const language = AVAILABLE_LANGUAGES.find(x => x.locale.toLowerCase() === lang.toLowerCase())

        const fallbackLocale = LOCALES_MAPPING[lang]?.fallbackLocale

        return {
            locale: language ? language.locale : fallbackLocale || FALLBACK_LOCALE,
            original: getFallbackLocale(language, lang)
        }
    }

    return {
        locale: FALLBACK_LOCALE,
        original: FALLBACK_LOCALE
    }
}

/**
 * get the local language string to load the language json
 * @param string
 * @returns string
 */
export function getLanguageCode(language) {
    const naviLang = window.navigator

    const parsedLocale = parseLocale(language)

    if (language && parsedLocale) {
        return parsedLocale
    } else if (typeof naviLang.languages !== 'undefined' && naviLang.languages.length > 0) {
        if (naviLang.languages[0].indexOf('-') > 0) {
            return parseLocale(naviLang.languages[0])
        } else {
            return parseLocale(naviLang.languages[0] + '-' + naviLang.languages[0])
        }
    } else {
        return parseLocale(FALLBACK_LOCALE)
    }
}
